import css from './ClearButton.module.css';
import BasicButton, { BasicButtonProps } from '../BasicButton/BasicButton';
import { ClearIcon } from '@shared/Icons/ClearIcon';
import React from 'react';

interface ClearButtonProps extends Omit<BasicButtonProps, 'children'> {
    iconWidth?: number;
    iconHeight?: number;
    iconFill?: string;
}

const ClearButton: React.FC<ClearButtonProps> = ({
    iconWidth = 21,
    iconHeight = 23,
    className = css.clearButton,
    iconFill = 'currentColor',
    ...rest
}) => {
    return (
        <BasicButton className={className} {...rest}>
            <ClearIcon width={iconWidth} height={iconHeight} fill={iconFill} />
        </BasicButton>
    );
};

export default React.memo(ClearButton);
